<template>
  <v-main>
    <div class="mx-4">
      <!-- Devices keeps one instance while the company slug in its path changes. -->
      <router-view :key="$route.name === 'Devices' ? 'Devices' : $route.path" />
    </div>
  </v-main>
</template>

<script>
export default {
  name: "DefaultView",
};
</script>
